import { useAuthStore } from '../stores/auth'
import { renew, logout } from '@/utils/auth'

const cfg = window.Config
export class StatusError extends Error {
  constructor(
    message: any,
    public status?: number,
  ) {
    super(message)
    this.name = 'StatusError'
  }
}

export function openURL(url: string, opts: ApiOpts): WindowProxy | null {
  opts = opts || {}
  opts.headers = opts.headers || {}
  const q: { [key: string]: any } = opts.query ?? {}

  const uri = new URL(url, cfg.BaseURL)
  Object.keys(q).forEach((key) => {
    if (Object.hasOwn(q, key)) uri.searchParams.append(key, q[key])
  })

  try {
    return window.open(uri.toString(), '_blank')
  } catch {
    throw new StatusError('000 No connection', 0)
  }
}

export async function fetchURL(url: string, opts: ApiOpts, auth = true): Promise<Response> {
  const authStore = useAuthStore()

  opts = opts || {}
  opts.headers = opts.headers || {}
  const q: { [key: string]: any } = opts.query ?? {}

  const uriStr = createURL(url, q)
  // Object.keys(q).forEach((key) => {
  //   if (Object.hasOwn(q, key)) uri.searchParams.append(key, q[key])
  // })

  const { headers, ...rest } = opts

  let res
  try {
    res = await fetch(uriStr, {
      headers: {
        Authorization: 'Bearer ' + authStore.jwt,
        ...headers,
      },
      ...rest,
    })
  } catch {
    throw new StatusError('000 No connection', 0)
  }

  if (auth && res.headers.get('X-Renew-Token') === 'true') {
    await renew(authStore.jwt)
  }

  if (res.status < 200 || res.status > 299) {
    const body = await res.text()
    const error = new StatusError(body || `${res.status} ${res.statusText}`, res.status)

    if (auth && res.status == 401) {
      logout()
    }

    throw error
  }

  return res
}

export async function fetchJSON<T>(url: string, opts?: any): Promise<T> {
  const res = await fetchURL(url, opts)

  if (res.status === 200) {
    return res.json() as Promise<T>
  }

  throw new StatusError(`${res.status} ${res.statusText}`, res.status)
}

export function removePrefix(url: string): string {
  url = url.split('/').splice(2).join('/')

  if (url === '') url = '/'
  if (url[0] !== '/') url = '/' + url
  return url
}

export function createURL(endpoint: string, params = {}): string {
  let prefix = cfg.BaseURL

  if (prefix) {
    if (!prefix.endsWith('/')) prefix = prefix + '/'
  } else prefix = document.location.origin

  const url = new URL(endpoint, prefix)

  const searchParams: SearchParams = {
    ...params,
  }

  for (const key in searchParams) {
    url.searchParams.set(key, searchParams[key])
  }

  return url.toString()
}
